var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.333,
    d: "m17.083 7.75 4.084-4.083M23.5 1.333l-2.333 2.334zM12.288 12.545a6.418 6.418 0 1 1-9.074 9.074 6.417 6.417 0 0 1 9.073-9.073zm0 0 4.795-4.795zm4.795-4.795 3.5 3.5 4.084-4.083-3.5-3.5z"
  })));
};
export default SvgKey;